// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","header":"styles_header__lMtkV","sticky":"styles_sticky__s-X2b","right-part-container":"styles_right-part-container__Vohv7"};